<form [formGroup]="form" novalidate>
  <div class="flex flex-col gap-1" [formArrayName]="'rows'">
    <div class="font-semibold leading-8" [ngClass]="rowClasses">
      @if (selectable) {
        <sb-checkbox
          [formControl]="form.get('selectAll')"
          [indeterminate]="someSelected"
          (change)="toggleSelectAll()"
        />
      }
      @for (column of columns; track column) {
        <span>{{ column }}</span>
      }
      <!-- Empty span for the 'remove row' column -->
      <span></span>
    </div>
    @for (row of rows.controls; let i = $index; track i) {
      <div [ngClass]="rowClasses" [formGroupName]="i" [attr.data-testid]="'dynamic-table-row-' + i">
        @if (selectable) {
          <sb-checkbox [formControl]="row.get('selected')" (change)="rowToggle.emit(i)" />
        }
        <ng-container *ngTemplateOutlet="rowTemplate; context: { $implicit: row }" />
        <button
          sb-icon-button
          [color]="'transparent'"
          [disabled]="!row.get('removable').value"
          (click)="removeRow.emit(i)"
          [attr.data-testid]="'dynamic-table-delete-row-' + i"
        >
          <sb-icon [name]="'trash'" />
        </button>
      </div>
    }
  </div>
  <!-- TODO wrapping element needed to make tooltip work on disabled element. Once https://differentlab.atlassian.net/browse/SHB-10501 is implemented, we can refactor this. -->
  <div
    class="inline-block grow-0"
    [sbTooltip]="addEntityDisabledTooltipLabel"
    [sbTooltipDisabled]="rows.length < entityLimit"
  >
    <button
      sb-button
      [disabled]="rows.length >= entityLimit"
      [color]="'outlinePrimary'"
      (click)="addRow.emit()"
      class="mt-3"
    >
      <sb-icon [name]="'plus'" />
      {{ addEntityLabel }}
    </button>
  </div>
</form>
